import { StubPage } from '../StubPage'
export function Steps() {
  return <StubPage title="Steps" summary="Steps are the individual units of work inside a Preparation. Each step has a type (Interviewer, Generator, Funnel), a position, and type-specific configuration. Steps execute sequentially — the Journey pauses at Interviewer steps until the user submits, then continues to the next step automatically." />
}
